import axios from 'axios';
import { TimelinePage, TrackRecordSummary } from '../types/trackRecord';

// Separate unauthenticated client — public users won't have tokens
const publicClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  headers: { 'Content-Type': 'application/json' },
});

publicClient.interceptors.response.use(
  (res) => res,
  (err) => {
    const detail = err.response?.data?.detail;
    const message = Array.isArray(detail)
      ? detail.map((d: any) => d.msg ?? JSON.stringify(d)).join('; ')
      : (detail || err.message || 'An error occurred');
    return Promise.reject(new Error(message));
  }
);

export const trackRecordService = {
  getTimeline: (params: { ticker?: string; page?: number; page_size?: number }) =>
    publicClient.get<TimelinePage>('/api/track-record', { params }).then((r) => r.data),

  getSummary: () =>
    publicClient.get<TrackRecordSummary>('/api/track-record/summary').then((r) => r.data),
};
